import posthog from "posthog-js";

// Only initialise when a token is configured for this environment (e.g. set in
// Vercel Production). Keeps staging/dev without the env var from erroring.
if (process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN) {
posthog.init(process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN, {
  api_host: "/ingest",
  ui_host: "https://eu.posthog.com",
  defaults: "2026-01-30",
  capture_exceptions: true,
  // Consent-gated: don't capture, persist, or set cookies until the user opts
  // into the "analytics" category. CookieConsent calls posthog.opt_in_capturing()
  // on consent and opt_out_capturing() on decline/withdraw. Matches Consent Mode.
  opt_out_capturing_by_default: true,
  debug: process.env.NODE_ENV === "development",
});
}
